var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhsErrorBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f58120;\n      }\n\n      .cls-2 {\n        fill: #ffe0c3;\n      }\n\n      .cls-3 {\n        fill: #ffddbe;\n      }\n\n      .cls-4 {\n        fill: #ffefe0;\n      }\n\n      .cls-5 {\n        fill: #ffebdd;\n      }\n\n      .cls-6 {\n        fill: #ffcfa1;\n      }\n\n      .cls-7 {\n        fill: #ff7e35;\n      }\n\n      .cls-8 {\n        fill: rgba(255, 224, 196, .5);\n      }\n\n      .cls-9 {\n        fill: rgba(255, 235, 221, .5);\n      }\n\n      .cls-10 {\n        fill: rgba(255, 152, 17, .2);\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m24.8,44.95h6.2v3.46h-6.2v-3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m31,44.95h6.2v3.46h-6.2v-3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m22.32,54.17c0,1.27,1.11,2.31,2.48,2.31h12.4c1.37,0,2.48-1.03,2.48-2.31s-1.11-2.31-2.48-2.31h-12.4c-1.37,0-2.48,1.03-2.48,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m22.32,58.78c0,1.27,1.11,2.31,2.48,2.31h12.4c1.37,0,2.48-1.03,2.48-2.31s-1.11-2.31-2.48-2.31h-12.4c-1.37,0-2.48,1.03-2.48,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m26.04,63.39c0,2.55,2.22,4.61,4.96,4.61s4.96-2.06,4.96-4.61v-2.31h-9.92v2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m22.32,49.56c0,1.27,1.11,2.31,2.48,2.31h12.4c1.37,0,2.48-1.03,2.48-2.31s-1.11-2.31-2.48-2.31h-12.4c-1.37,0-2.48,1.03-2.48,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m28.52,32.27h-3.72c-2.05,0-3.72-1.55-3.72-3.46s1.67-3.46,3.72-3.46,3.72,1.55,3.72,3.46v3.46h2.48V10.37c-10.96,0-19.84,8.26-19.83,18.45,0,7.51,4.9,14.27,12.39,17.09,2.36.9,4.89,1.35,7.44,1.35v-14.98h-2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m31,10.37v21.9h2.48v-3.46c0-1.91,1.67-3.46,3.72-3.46s3.72,1.55,3.72,3.46-1.67,3.46-3.72,3.46h-6.2v14.98c2.55,0,5.08-.45,7.44-1.35,10.16-3.82,15.06-14.57,10.94-24.01-3.03-6.96-10.3-11.52-18.38-11.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m13.75,13.58c-.33,0-.64-.12-.88-.34l-3.51-3.26c-.48-.46-.46-1.19.03-1.63.48-.43,1.24-.43,1.72,0l3.51,3.26c.48.45.48,1.18,0,1.63-.23.22-.55.34-.88.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m10.24,49.44c-.68,0-1.24-.52-1.24-1.15,0-.31.13-.6.36-.81l3.51-3.26c.48-.46,1.26-.47,1.75-.03.49.44.51,1.17.03,1.63-.01,0-.02.02-.03.03l-3.51,3.26c-.23.22-.55.34-.88.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m52.33,49.44c-.33,0-.64-.12-.88-.34l-3.51-3.26c-.49-.44-.51-1.17-.03-1.63.48-.46,1.26-.47,1.75-.03.01,0,.02.02.03.03l3.51,3.26c.48.45.48,1.18,0,1.63-.23.22-.55.34-.88.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m48.82,13.58c-.68,0-1.24-.52-1.24-1.15,0-.31.13-.6.36-.81l3.51-3.26c.48-.46,1.26-.47,1.75-.03.49.44.51,1.17.03,1.63-.01,0-.02.02-.03.03l-3.51,3.26c-.23.22-.55.34-.88.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m31,6.92c-.68,0-1.24-.52-1.24-1.15V1.15c0-.64.56-1.15,1.24-1.15s1.24.52,1.24,1.15v4.61c0,.64-.55,1.15-1.24,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m6.2,29.97H1.24c-.68,0-1.24-.52-1.24-1.15s.56-1.15,1.24-1.15h4.96c.68,0,1.24.52,1.24,1.15s-.55,1.15-1.24,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m60.76,29.97h-4.96c-.68,0-1.24-.52-1.24-1.15s.56-1.15,1.24-1.15h4.96c.68,0,1.24.52,1.24,1.15s-.56,1.15-1.24,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m29.34,33.51h2.83v2.83h-2.83v-2.83Zm0-11.33h2.83v8.5h-2.83v-8.5Zm1.4-7.08c-7.82,0-14.15,6.35-14.15,14.17s6.33,14.17,14.15,14.17,14.18-6.35,14.18-14.17-6.35-14.17-14.18-14.17Zm.01,25.5c-6.26,0-11.33-5.07-11.33-11.33s5.07-11.33,11.33-11.33,11.33,5.07,11.33,11.33-5.07,11.33-11.33,11.33Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhsErrorBulb);
export default __webpack_public_path__ + "static/media/WHSErrorBulb.fcfeeb8336cd15e44da0cc21ac889235.svg";
export { ForwardRef as ReactComponent };